import { HighChartDataBase } from './high-chart-data-base';
import { ClickDataPoint } from './click-notifier';

export class DateTimeHighChartData extends HighChartDataBase {

    private isDateWithTime(dateobj: Date): boolean {
        let hour = dateobj.getHours();
        let minute = dateobj.getMinutes();
        let second = dateobj.getSeconds();
        return hour != 0 && minute != 0 && second != 0;
    }
    private serieDataContainsTime(data): boolean {
        for (var i = 0; i < data.length; i += 1) {
            if (this.isDateWithTime(data[i]['x'])) {
                return true;
            }
        }
        return false;
    }

    private dateFormat = "YYYY-MM-DD";

    public getHighChartOptions(): Object {
        let that = this;
        this.chartSeries.forEach((chartSerie) => {
            chartSerie.data = chartSerie.data.map(function(p) {
                p.x = p.name; // datetime-grafer måste ha x-värde.
                return p;
            });
            if (that.serieDataContainsTime(chartSerie.data)) {
                that.dateFormat = "YYYY-MM-DD HH:mm";
            }
            chartSerie.type = chartSerie.type != 'column' ? null : 'column'; // datetime-grafer får inte ha type (undantag om type är satt till column)
        });
        let options = {
            accessability: { enabled: false },
            chart: {
                type: 'line',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.chartSubTitle,
                widthAdjust: -150
            },
            yAxis: this.getYAxis(),
            series: this.chartSeries,
            xAxis: {
                type: "datetime",
                title: { 
                    text: this.xAxisTitle 
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue,
                dateTimeLabelFormats: {
                    day: '%e %b',
                    week: '%e %b',
                    month: '%b %y'
                }
            },
            tooltip: {
                formatter: function() { return that.getDefaultTooltipText(this, true, that.dateFormat); },
                shared: true,
                useHTML: true
            },
            plotOptions: {
                line: {
                    point: {
                        events: {
                            click: function () {
                                if (that.clickNotifier) {
                                    that.clickNotifier.handleClick(new ClickDataPoint(this.category, this.series.name, this.y));
                                }
                            }
                        }
                    }
                }
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1 ? true : false
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },
            boost: {
                useGPUTranslations: true
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
        return options;
    }

    /**
     * Hämta Y-axlar
     */
    private getYAxis() {
        let firstYAxis = this.createYAxis(this.yAxisTitle, this.yAxisTitleColor, this.yMinValue, this.yMaxValue);
        if (!this.hasY2Axis) { 
            //Om det endast finns en y-axis
            return firstYAxis;
        }
        else {
            // Om det finns två y-axlar
            let yAxis = [];
            yAxis.push(firstYAxis);
            let secondYAxis = this.createYAxis(this.y2AxisTitle, this.y2AxisTitleColor, this.y2MinValue, this.y2MaxValue, true);
            yAxis.push(secondYAxis);
            return yAxis;
        }
    }
}
